module.exports = __webpack_public_path__ + "img/Cierges_magiques.d96fa39.jpg";